import { apiAxios as authAxios } from '../axios.config';

export const getTicket = () => {
  return authAxios.get('/api/tickets');
};
